<template>
  <v-dialog v-model="dialog" width="600">
    <gg-card>
      <gg-toolbar @close="close">
        Warning: Content Exists
      </gg-toolbar>
      <gg-card-text>
        <v-row>
          <v-col cols="12" class="pb-0">
            <p class="mb-0">
              Content currently exists on your domain {{ softdomain }}. You must first uninstall it before proceeding with a new installation.
            </p>
          </v-col>
        </v-row>
      </gg-card-text>
      <v-card-actions class="px-5 pt-0 pb-3 justify-content-end">
        <gg-btn @click="close">Understand</gg-btn>
      </v-card-actions>
    </gg-card>
  </v-dialog>
</template>

<script>
import modalMixin from '@/mixins/modal'

export default {
  name: 'InstallationExistsModal',
  mixins: [modalMixin],
  props: {
    softdomain: {
      type: String,
      required: true
    }
  },
  methods: {
    overwrite () {
      this.close()
    }
  }
}
</script>
